import { createApp } from 'vue'
import {
  // Komponen yang sudah ada
  Radio,
  Spin,
  Col,
  Row,
  Popconfirm,
  Form,
  Divider,
  Button,
  Layout,
  Drawer,
  Menu,
  Avatar,
  Dropdown,
  Input,
  Popover,
  Upload,
  Pagination,
  Select,
  Checkbox,
  Modal,
  Tag,
  Table,
  AutoComplete,
  Card,
  DatePicker,
  Tabs,
  PageHeader,
  Descriptions,
  InputNumber,
  Space,
  Result,
  Tooltip,
  Carousel,
  Calendar,
  Badge,
  TimePicker,
  Switch,
  Collapse,
  CollapsePanel,
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbSeparator,
  Alert,
} from 'ant-design-vue'
import PerfectScrollbar from 'vue3-perfect-scrollbar'

// Import Google Fonts
import '@fontsource/barlow'
import '@fontsource/lato'

import App from './App.vue'
import router from './router'
import store from './store'
import VueApexCharts from 'vue3-apexcharts'
import './mixins.scss'
import moment from 'moment'
import 'moment/locale/id'

moment.locale('id')
const app = createApp(App)
app.config.globalProperties.$moment = moment
app.component('Apexchart', VueApexCharts)
app
  .use(store)
  .use(router)
  // ... .use() untuk komponen yang sudah ada
  .use(VueApexCharts)
  .use(Radio)
  .use(Calendar)
  .use(DatePicker)
  .use(Col)
  .use(Spin)
  .use(Row)
  .use(Carousel)
  .use(AutoComplete)
  .use(Pagination)
  .use(Popconfirm)
  .use(Form)
  .use(Divider)
  .use(Button)
  .use(Layout)
  .use(Drawer)
  .use(Menu)
  .use(Avatar)
  .use(Dropdown)
  .use(Input)
  .use(Popover)
  .use(Upload)
  .use(Select)
  .use(Checkbox)
  .use(Modal)
  .use(Tag)
  .use(Table)
  .use(Tabs)
  .use(Result)
  .use(Card)
  .use(PageHeader)
  .use(Descriptions)
  .use(InputNumber)
  .use(Space)
  .use(Tooltip)
  .use(Badge)
  .use(TimePicker)
  .use(Switch)
  .use(Collapse)
  .use(CollapsePanel)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(BreadcrumbSeparator)
  .use(Alert)

  .use(PerfectScrollbar)
  .mount('#app')
